import { Helmet } from "react-helmet-async";
import Hero from "../../components/home/Hero";
import Stats from "../../components/home/Stats";
import AboutPreview from "../../components/home/AboutPreview";
import ProgramsSection from "../../components/home/ProgramsSection";
import WhyChooseUs from "../../components/home/WhyChooseUs";
import TransformationSection from "../../components/home/TransformationSection";
import TrainingExperience from "../../components/home/TrainingExperience";
import ScheduleSection from "../../components/home/ScheduleSection";
import BMICalculator from "../../components/home/BMICalculator";
import TrainersPreview from "../../components/home/TrainersPreview";
import MembershipSection from "../../components/home/MembershipSection";
import TestimonialsSection from "../../components/home/TestimonialsSection";
import GalleryPreview from "../../components/home/GalleryPreview";
import FinalCTA from "../../components/home/FinalCTA";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Firm Fit Factory | Premium Gym in Peelamedu, Coimbatore</title>
        <meta
          name="description"
          content="Firm Fit Factory is a premium gym and fitness centre in Peelamedu, Coimbatore offering strength training, personal training, weight management and more."
        />
        <link rel="canonical" href="https://www.firmfitfactory.com/" />
        <meta property="og:title" content="Firm Fit Factory | Premium Gym in Peelamedu, Coimbatore" />
        <meta property="og:description" content="Coached strength and fitness training in Peelamedu, Coimbatore. Explore programs, trainers and membership plans." />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "HealthClub",
            name: "Firm Fit Factory",
            image: "",
            telephone: "+91 95008 86368",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Maheshwari Nagar, Vilangurichi Road, 4th Street",
              addressLocality: "Peelamedu, Coimbatore",
              addressRegion: "Tamil Nadu",
              postalCode: "641004",
              addressCountry: "IN",
            },
          })}
        </script>
      </Helmet>
      <Hero />
      <Stats />
      <AboutPreview />
      <ProgramsSection />
      <WhyChooseUs />
      <TransformationSection />
      <TrainingExperience />
      <ScheduleSection />
      <BMICalculator />
      <TrainersPreview />
      <MembershipSection />
      <TestimonialsSection />
      <GalleryPreview />
      <FinalCTA />
    </>
  );
}
